import { Colors } from './'

const theme: Colors = {
  primary: '#dd0330',
  dark: '#133046',
  red: '#C7402D',
  white: '#FAFAFA',
  gray: '#EAEAEA',
  black: '#333',
}

export default theme
